import React, { memo } from 'react';
import { Card, Divider, Skeleton, Stack } from 'investira.react.components';

const FeederMasterListSkeleton = memo(() => {
  return (
    <Stack>
      <Stack mb={2}>
        <Skeleton variant="text" width={220} height={20} />
      </Stack>

      <Stack component="ul" sx={{ m: 0, p: 0, listStyle: 'none' }}>
        {Array.from({ length: 10 }).map((_, xIndex) => (
          <Card
            key={`feeder-master-skeleton-${xIndex}`}
            component="li"
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '70% 30%',
                sm: '90% 10%'
              },
              gap: 2,
              px: 2,
              py: 2,
              mb: 1.5,
              backgroundColor: 'background.paper'
            }}>
            <Stack
              direction={{
                xs: 'column',
                sm: 'row'
              }}
              gap={1.5}>
              <Stack flex={1} minWidth={0}>
                <Skeleton variant="text" width={52} height={20} />
                <Stack direction="row" spacing={1.5} alignItems="flex-start">
                  <Skeleton variant="rounded" width={32} height={32} />
                  <Stack minWidth={0}>
                    <Skeleton variant="text" width={170} height={22} />
                    <Skeleton variant="text" width={140} height={18} />
                    <Skeleton variant="text" width={110} height={18} />
                  </Stack>
                </Stack>
              </Stack>

              <Divider flexItem orientation="vertical" />

              <Stack flex={1} minWidth={0}>
                <Skeleton variant="text" width={52} height={20} />
                <Stack direction="row" spacing={1.5} alignItems="flex-start">
                  <Skeleton variant="rounded" width={32} height={32} />
                  <Stack minWidth={0}>
                    <Skeleton variant="text" width={170} height={22} />
                    <Skeleton variant="text" width={140} height={18} />
                    <Skeleton variant="text" width={110} height={18} />
                  </Stack>
                </Stack>
              </Stack>
            </Stack>

            <Stack justifyContent={{ xs: 'flex-start', sm: 'center' }} alignItems="center">
              <Skeleton variant="circular" width={40} height={40} />
            </Stack>
          </Card>
        ))}
      </Stack>
    </Stack>
  );
});

FeederMasterListSkeleton.displayName = 'FeederMasterListSkeleton';

export default FeederMasterListSkeleton;
